// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as Data from "common/src/data/Data.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as Jotai from "jotai";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as CdnAtom from "common/src/atoms/CdnAtom.bs.js";
import * as TbAtoms from "../team-planner-core/TbAtoms.bs.js";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as TbHexName from "../team-planner-core/TbHexName.bs.js";
import * as TbHexWrap from "../team-planner-core/TbHexWrap.bs.js";
import * as TbUtils76 from "./TbUtils76.bs.js";
import * as ReactDnd from "react-dnd";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ScreenAtom from "common/src/atoms/ScreenAtom.bs.js";
import * as TraitImage from "common/src/tft-static/TraitImage.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as ItemTooltip from "common/src/tft-static/ItemTooltip.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as UnitTooltip from "common/src/tft-static/UnitTooltip.bs.js";
import * as TbHexStarLevel from "../team-planner-core/TbHexStarLevel.bs.js";
import Popover from "@mui/material/Popover";
import MenuItem from "@mui/material/MenuItem";
import Star from "@mui/icons-material/Star";
import Clear from "@mui/icons-material/Clear";

function getItemPosition(idx, count) {
  switch (idx) {
    case 0 :
        switch (count) {
          case 1 :
              return [
                      31,
                      2
                    ];
          case 2 :
              return [
                      18,
                      2
                    ];
          case 3 :
              return [
                      6,
                      2
                    ];
          default:
            
        }
        break;
    case 1 :
        if (count === 2) {
          return [
                  43,
                  2
                ];
        }
        if (count === 3) {
          return [
                  31,
                  2
                ];
        }
        break;
    case 2 :
        if (count === 3) {
          return [
                  56,
                  2
                ];
        }
        break;
    default:
      
  }
  throw {
        RE_EXN_ID: "Assert_failure",
        _1: [
          "TeamPlannerHex76.res",
          11,
          9
        ],
        Error: new Error()
      };
}

function TeamPlannerHex76$Item(Props) {
  var itemId = Props.itemId;
  var idx = Props.idx;
  var colNum = Props.colNum;
  var rowNum = Props.rowNum;
  var onRemove = Props.onRemove;
  var basePath4 = CdnAtom.usePath4(undefined);
  var match = Jotai.useAtom(TbAtoms.disableTooltips);
  var match$1 = ReactDnd.useDrag({
        type: "hex-item",
        item: {
          id: itemId,
          type: "hex-item",
          idx: idx,
          colNum: colNum,
          rowNum: rowNum
        },
        end: (function (_item, monitor) {
            if (!monitor.didDrop()) {
              return Curry._3(onRemove, colNum, rowNum, idx);
            }
            
          }),
        collect: (function (monitor) {
            return {
                    isDragging: monitor.isDragging()
                  };
          })
      });
  return React.createElement("g", {
              ref: match$1[1]
            }, React.createElement(ItemTooltip.make, {
                  itemId: itemId,
                  children: React.createElement("rect", {
                        height: "25",
                        width: "25",
                        stroke: "rgba(255, 255, 255, 0.8)",
                        strokeWidth: "1",
                        x: "0.5",
                        y: "0.5"
                      }),
                  disabled: match[0]
                }), React.createElement("image", {
                  className: "pointer-events-none " + (
                    match$1[0].isDragging ? "opacity-50" : ""
                  ),
                  height: "24",
                  href: basePath4 + "/items_s14/" + itemId + ".jpg?w=24",
                  width: "24",
                  x: "1",
                  y: "1"
                }));
}

var Item = {
  make: TeamPlannerHex76$Item
};

function TeamPlannerHex76$Unit(Props) {
  var grayscale = Props.grayscale;
  var dragRef = Props.dragRef;
  var isDragging = Props.isDragging;
  var highlightTrait = Props.highlightTrait;
  var hexSize = Props.hexSize;
  var hexContent = Props.hex;
  var colNum = Props.colNum;
  var rowNum = Props.rowNum;
  var onRemove = Props.onRemove;
  var onRemoveItem = Props.onRemoveItem;
  var onUpdateHex = Props.onUpdateHex;
  var traitCounts = Props.traitCounts;
  var extraTrait = Props.extraTrait;
  var set = TftSet.use(undefined);
  var basePath3 = CdnAtom.usePath4(undefined);
  var t = Translation.useT(/* Common */0);
  var unitsT = Translation.useT(/* Units */1);
  Translation.useT(/* Traits */2);
  var match = Jotai.useAtom(TbAtoms.disableTooltips);
  var disableTooltips = match[0];
  var match$1 = Jotai.useAtom(TbAtoms.compactMode);
  var compactMode = match$1[0];
  var lang = Translation.useLocale();
  var match$2 = Jotai.useAtom(TbAtoms.useSkins);
  var match$3 = Jotai.useAtom(TbAtoms.showNames);
  var screenSize = ScreenAtom.use(undefined);
  var match$4 = React.useState(function () {
        
      });
  var modifier = hexContent.modifier;
  var starLevel = hexContent.starLevel;
  var items = hexContent.items;
  var unit = hexContent.unit;
  var setMenuAnchor = match$4[1];
  var menuAnchor = match$4[0];
  var traits;
  traits = unit.TAG === /* Unit */0 ? Sd.getUnitTraits(unit._0, set).slice(0) : [];
  if (unit.TAG === /* Unit */0) {
    switch (unit._0) {
      case "TFT15_Ekko" :
          if (modifier !== undefined) {
            switch (modifier) {
              case 0 :
                  traits.push("TFT15_Spellslinger");
                  break;
              case 1 :
                  traits.push("TFT15_Prodigy");
                  break;
              case 2 :
                  traits.push("TFT15_Strategist");
                  break;
              default:
                
            }
          }
          break;
      case "TFT15_LeeSin" :
          if (modifier !== undefined) {
            switch (modifier) {
              case 0 :
                  traits.push("TFT15_Duelist");
                  break;
              case 1 :
                  traits.push("TFT15_Destroyer");
                  break;
              case 2 :
                  traits.push("TFT15_Juggernaut");
                  break;
              default:
                
            }
          }
          break;
      default:
        
    }
  }
  if (extraTrait !== undefined) {
    traits.push(extraTrait);
  }
  var isHighlighted = highlightTrait !== undefined ? Belt_Array.some(traits, (function (tt) {
            return tt === highlightTrait;
          })) : true;
  var tmp = {
    className: isHighlighted && !isDragging ? "" : "opacity-30"
  };
  if (dragRef !== undefined) {
    tmp.ref = Caml_option.valFromOption(dragRef);
  }
  var size = String(((hexSize | 0) << 1) - 2 | 0);
  var tmp$1;
  if (unit.TAG === /* Unit */0) {
    var unitId = unit._0;
    if (unitId === "TFT15_Lulu") {
      var unitId$1;
      if (modifier !== undefined) {
        switch (modifier) {
          case 0 :
              unitId$1 = "TFT15_KogMaw";
              break;
          case 1 :
              unitId$1 = "TFT15_Rammus";
              break;
          case 2 :
              unitId$1 = "TFT15_Smolder";
              break;
          default:
            unitId$1 = "TFT15_Lulu";
        }
      } else {
        unitId$1 = "TFT15_Lulu";
      }
      tmp$1 = basePath3 + "/dc15/face_full/" + unitId$1 + ".png?w=" + size;
    } else {
      var unitId$2 = unitId.startsWith("TFT7_Nomsy") ? "TFT7_Nomsy" : unitId;
      tmp$1 = match$2[0] ? basePath3 + "/face_full/" + unitId$2 + ".jpg?w=" + size : basePath3 + "/face_base_full/" + Belt_Array.getExn(unitId$2.split("_"), 1) + ".jpg?w=" + size;
    }
  } else {
    switch (unit._0) {
      case /* Mech */0 :
          tmp$1 = basePath3 + "/dc15/face_full/TFT15_MightyMech.png.jpg?w=" + size;
          break;
      case /* Sentinel */1 :
          tmp$1 = basePath3 + "/face_full/TFT_BlueGolem.jpg?w=" + size;
          break;
      case /* Dummy */2 :
          tmp$1 = basePath3 + "/face_full/TFT_TrainingDummy.jpg?w=" + size;
          break;
      case /* MonsterTrainer */3 :
          var unitId$3;
          if (modifier !== undefined) {
            switch (modifier) {
              case 0 :
                  unitId$3 = "TFT15_KogMaw";
                  break;
              case 1 :
                  unitId$3 = "TFT15_Rammus";
                  break;
              case 2 :
                  unitId$3 = "TFT15_Smolder";
                  break;
              default:
                unitId$3 = "TFT15_Rammus";
            }
          } else {
            unitId$3 = "TFT15_Rammus";
          }
          tmp$1 = basePath3 + "/dc15/face_full/" + unitId$3 + ".png?w=" + size;
          break;
      case /* ZyraPlant */4 :
          var key = rowNum <= 1 || rowNum >= 6 ? "2" : "1";
          tmp$1 = basePath3 + "/dc15/face_full/TFT15_ZyraPlant" + key + ".jpg?w=" + size;
          break;
      
    }
  }
  var tmp$2;
  if (unit.TAG === /* Unit */0) {
    var match$5 = Sd.unitTier(unit._0);
    switch (match$5) {
      case 1 :
          tmp$2 = "rgba(187, 187, 187, 0.75)";
          break;
      case 2 :
          tmp$2 = "rgba(55, 212, 136, 0.75)";
          break;
      case 3 :
          tmp$2 = "rgba(110, 204, 255, 0.75)";
          break;
      case 4 :
          tmp$2 = "rgba(227, 50, 199, 0.75)";
          break;
      case 5 :
          tmp$2 = "rgba(255, 205, 79, 0.75)";
          break;
      default:
        tmp$2 = "rgba(187, 187, 187, 0.75)";
    }
  } else {
    tmp$2 = (unit._0 - 1 >>> 0) > 1 ? "rgba(110, 204, 255, 0.75)" : "rgba(187, 187, 187, 0.75)";
  }
  var content = React.createElement("path", {
        onClick: (function (e) {
            if (screenSize < 4) {
              return ;
            }
            e.preventDefault();
            e.stopPropagation();
            var target = e.currentTarget;
            return Curry._1(setMenuAnchor, (function (param) {
                          return Caml_option.some(target);
                        }));
          }),
        onContextMenu: (function (e) {
            if (screenSize >= 4) {
              return ;
            }
            e.preventDefault();
            e.stopPropagation();
            var target = e.currentTarget;
            return Curry._1(setMenuAnchor, (function (param) {
                          return Caml_option.some(target);
                        }));
          }),
        d: T.genHexPath(hexSize),
        fill: "transparent",
        stroke: tmp$2,
        strokeWidth: "3.5",
        transform: "translate(0.5, 0.5)"
      });
  var tmp$3;
  if (unit.TAG === /* Unit */0) {
    var unitId$4 = unit._0;
    if (unitId$4 === "TFT15_Lulu") {
      var unitId$5;
      if (modifier !== undefined) {
        switch (modifier) {
          case 0 :
              unitId$5 = "TFT15_KogMaw";
              break;
          case 1 :
              unitId$5 = "TFT15_Rammus";
              break;
          case 2 :
              unitId$5 = "TFT15_Smolder";
              break;
          default:
            unitId$5 = "TFT15_Lulu";
        }
      } else {
        unitId$5 = "TFT15_Lulu";
      }
      tmp$3 = React.createElement(UnitTooltip.make, {
            disabled: disableTooltips,
            unit: unitId$5,
            children: content
          });
    } else {
      tmp$3 = React.createElement(UnitTooltip.make, {
            disabled: disableTooltips,
            unit: unitId$4,
            children: content
          });
    }
  } else {
    switch (unit._0) {
      case /* Mech */0 :
          tmp$3 = React.createElement(UnitTooltip.make, {
                disabled: disableTooltips,
                unit: "TFT15_Galio",
                children: content
              });
          break;
      case /* Sentinel */1 :
      case /* Dummy */2 :
          tmp$3 = content;
          break;
      case /* MonsterTrainer */3 :
          var unitId$6;
          if (modifier !== undefined) {
            switch (modifier) {
              case 0 :
                  unitId$6 = "TFT15_KogMaw";
                  break;
              case 1 :
                  unitId$6 = "TFT15_Rammus";
                  break;
              case 2 :
                  unitId$6 = "TFT15_Smolder";
                  break;
              default:
                unitId$6 = "TFT15_Rammus";
            }
          } else {
            unitId$6 = "TFT15_Rammus";
          }
          tmp$3 = React.createElement(UnitTooltip.make, {
                disabled: disableTooltips,
                unit: unitId$6,
                children: content
              });
          break;
      case /* ZyraPlant */4 :
          var unitId$7 = rowNum <= 1 || rowNum >= 6 ? "TFT15_ZyraGraspingPlant" : "TFT15_ZyraThornPlant";
          tmp$3 = React.createElement(UnitTooltip.make, {
                disabled: disableTooltips,
                unit: unitId$7,
                children: content
              });
          break;
      
    }
  }
  var tmp$4;
  if (match$3[0]) {
    var nameParts;
    if (unit.TAG === /* Unit */0) {
      var unitId$8 = unit._0;
      if (unitId$8 === "TFT15_Lulu") {
        var unitId$9;
        if (modifier !== undefined) {
          switch (modifier) {
            case 0 :
                unitId$9 = "TFT15_KogMaw";
                break;
            case 1 :
                unitId$9 = "TFT15_Rammus";
                break;
            case 2 :
                unitId$9 = "TFT15_Smolder";
                break;
            default:
              unitId$9 = "TFT15_Lulu";
          }
        } else {
          unitId$9 = "TFT15_Lulu";
        }
        nameParts = [unitsT(unitId$9)];
      } else {
        nameParts = [unitsT(unitId$8)];
      }
    } else {
      switch (unit._0) {
        case /* Mech */0 :
            nameParts = [unitsT("TFT15_Galio")];
            break;
        case /* Sentinel */1 :
            nameParts = [t("TFT_BlueGolem")];
            break;
        case /* Dummy */2 :
            nameParts = [t("")];
            break;
        case /* MonsterTrainer */3 :
            var unitId$10;
            if (modifier !== undefined) {
              switch (modifier) {
                case 0 :
                    unitId$10 = "TFT15_KogMaw";
                    break;
                case 1 :
                    unitId$10 = "TFT15_Rammus";
                    break;
                case 2 :
                    unitId$10 = "TFT15_Smolder";
                    break;
                default:
                  unitId$10 = "TFT15_Rammus";
              }
            } else {
              unitId$10 = "TFT15_Rammus";
            }
            nameParts = [unitsT(unitId$10)];
            break;
        case /* ZyraPlant */4 :
            var unitId$11 = rowNum <= 1 || rowNum >= 6 ? "TFT15_ZyraGraspingPlant" : "TFT15_ZyraThornPlant";
            nameParts = [unitsT(unitId$11)];
            break;
        
      }
    }
    tmp$4 = React.createElement(TbHexName.make, {
          lang: lang,
          nameParts: nameParts
        });
  } else {
    tmp$4 = null;
  }
  var tmp$5;
  if (compactMode) {
    tmp$5 = null;
  } else {
    var match$6 = Belt_Array.partition(items, (function (itemId) {
            return !itemId.includes("Chempunk");
          }));
    var itemCount = match$6[0].length;
    var currModsCount = {
      contents: 0
    };
    var numMods = Belt_Array.keep(items, (function (itemId) {
            return Data.itemInfoExn(itemId, set).tags.includes("Mod");
          })).length;
    tmp$5 = React.createElement(React.Fragment, undefined, React.createElement("g", {
              transform: "translate(0, 69)"
            }, Belt_Array.mapWithIndex(items, (function (idx, itemId) {
                    if (Data.itemInfoExn(itemId, set).tags.includes("Mod")) {
                      currModsCount.contents = currModsCount.contents + 1 | 0;
                      return React.createElement("g", {
                                  transform: "translate(69, -42)"
                                }, React.createElement(TeamPlannerHex76$Item, {
                                      itemId: itemId,
                                      idx: idx,
                                      colNum: colNum,
                                      rowNum: rowNum,
                                      onRemove: onRemoveItem
                                    }));
                    }
                    var match = getItemPosition(idx - currModsCount.contents | 0, itemCount - numMods | 0);
                    return React.createElement("g", {
                                key: String(idx),
                                transform: "translate(" + String(match[0]) + ", " + String(match[1]) + ")"
                              }, React.createElement(TeamPlannerHex76$Item, {
                                    itemId: itemId,
                                    idx: idx,
                                    colNum: colNum,
                                    rowNum: rowNum,
                                    onRemove: onRemoveItem
                                  }));
                  }))));
  }
  return React.createElement("g", tmp, React.createElement(Popover, {
                  open: Belt_Option.isSome(menuAnchor),
                  onClose: (function (param) {
                      return Curry._1(setMenuAnchor, (function (param) {
                                    
                                  }));
                    }),
                  anchorEl: menuAnchor,
                  children: React.createElement("div", {
                        className: "py-[6px]"
                      }, React.createElement(MenuItem, {
                            classes: {
                              root: starLevel === 2 ? "text-primary-11" : "text-white1"
                            },
                            onClick: (function (param) {
                                Curry._3(onUpdateHex, colNum, rowNum, {
                                      unit: hexContent.unit,
                                      items: hexContent.items,
                                      starLevel: starLevel === 2 ? 0 : 2,
                                      chosenTrait: hexContent.chosenTrait,
                                      modifier: hexContent.modifier
                                    });
                                return Curry._1(setMenuAnchor, (function (param) {
                                              
                                            }));
                              }),
                            children: React.createElement("div", {
                                  className: "flex"
                                }, React.createElement("div", {
                                      className: "mt-[-2px] pl-[1px]"
                                    }, React.createElement(Star, {
                                          fontSize: "small",
                                          color: "inherit"
                                        })), React.createElement("div", {
                                      className: "pl-[9px]"
                                    }, t("2-Star")))
                          }), React.createElement(MenuItem, {
                            classes: {
                              root: starLevel === 3 ? "text-primary-11" : "text-white1"
                            },
                            onClick: (function (param) {
                                Curry._3(onUpdateHex, colNum, rowNum, {
                                      unit: hexContent.unit,
                                      items: hexContent.items,
                                      starLevel: starLevel === 3 ? 0 : 3,
                                      chosenTrait: hexContent.chosenTrait,
                                      modifier: hexContent.modifier
                                    });
                                return Curry._1(setMenuAnchor, (function (param) {
                                              
                                            }));
                              }),
                            children: React.createElement("div", {
                                  className: "flex"
                                }, React.createElement("div", {
                                      className: "mt-[-2px] pl-[1px]"
                                    }, React.createElement(Star, {
                                          fontSize: "small",
                                          color: "inherit"
                                        })), React.createElement("div", {
                                      className: "pl-[9px]"
                                    }, t("3-Star")))
                          }), React.createElement(MenuItem, {
                            classes: {
                              root: starLevel === 4 ? "text-primary-11" : "text-white1"
                            },
                            onClick: (function (param) {
                                Curry._3(onUpdateHex, colNum, rowNum, {
                                      unit: hexContent.unit,
                                      items: hexContent.items,
                                      starLevel: starLevel === 4 ? 0 : 4,
                                      chosenTrait: hexContent.chosenTrait,
                                      modifier: hexContent.modifier
                                    });
                                return Curry._1(setMenuAnchor, (function (param) {
                                              
                                            }));
                              }),
                            children: React.createElement("div", {
                                  className: "flex"
                                }, React.createElement("div", {
                                      className: "mt-[-2px] pl-[1px]"
                                    }, React.createElement(Star, {
                                          fontSize: "small",
                                          color: "inherit"
                                        })), React.createElement("div", {
                                      className: "pl-[9px]"
                                    }, t("4-Star")))
                          }), React.createElement(MenuItem, {
                            onClick: (function (param) {
                                Curry._1(onRemove, undefined);
                                return Curry._1(setMenuAnchor, (function (param) {
                                              
                                            }));
                              }),
                            children: React.createElement("div", {
                                  className: "flex"
                                }, React.createElement("div", {
                                      className: "mt-[-2px] pl-[1px]"
                                    }, React.createElement(Clear, {
                                          fontSize: "small",
                                          color: "inherit"
                                        })), React.createElement("div", {
                                      className: "pl-[9px]"
                                    }, "Remove"))
                          }))
                }), React.createElement("g", {
                  className: "pointer-events-none"
                }, React.createElement("image", {
                      height: size,
                      href: tmp$1,
                      width: size,
                      clipPath: "polygon(50% 0%, 93.301270189% 25%, 93.301270189% 75%, 50% 100%, 6.698729811% 75%, 6.698729811% 25%)",
                      filter: Caml_obj.caml_equal(grayscale, true) ? "url(#grayscale)" : "",
                      x: "-5",
                      y: "2"
                    })), tmp$3, tmp$4, tmp$5, compactMode ? null : Belt_Array.mapWithIndex(traits, (function (idx, t) {
                      var count = Belt_Option.mapWithDefault(Caml_option.undefined_to_opt(traitCounts.find(function (param) {
                                    return t === param[0];
                                  })), 0, (function (prim) {
                              return prim[1];
                            }));
                      var rank = Sd.traitRank(t, count, set);
                      var rank$1 = t === "TFT15_TheCrew" ? (
                          count >= 2 ? (
                              rank < 3 ? rank : 3
                            ) : 0
                        ) : rank;
                      var match = traits.length;
                      var x = match !== 2 ? (
                          match !== 3 ? Global.f(Math.imul(idx, 25)) + 29.5 : Global.f(Math.imul(idx, 25)) + 4.5
                        ) : Global.f(Math.imul(idx, 25)) + 18;
                      return React.createElement("g", {
                                  key: t,
                                  className: "pointer-events-none",
                                  transform: "translate(" + Global.toFixed(undefined, x) + ", -3)"
                                }, React.createElement(TraitImage.make, {
                                      traitId: t,
                                      rank: rank$1,
                                      size: 26
                                    }));
                    })), React.createElement(TbHexStarLevel.make, {
                  starLevel: starLevel > 1 ? starLevel : 1
                }));
}

var Unit = {
  make: TeamPlannerHex76$Unit
};

function TeamPlannerHex76(Props) {
  var highlightTrait = Props.highlightTrait;
  var hexSize = Props.hexSize;
  var xGridSize = Props.xGridSize;
  var yGridSize = Props.yGridSize;
  var extended = Props.extended;
  var colNum = Props.colNum;
  var rowNum = Props.rowNum;
  var onDrop = Props.onDrop;
  var onMove = Props.onMove;
  var onDropItem = Props.onDropItem;
  var onMoveItem = Props.onMoveItem;
  var onRemove = Props.onRemove;
  var onRemoveItem = Props.onRemoveItem;
  var onUpdateHex = Props.onUpdateHex;
  var onToggleMech = Props.onToggleMech;
  var hex = Props.hex;
  var highlight = Props.highlight;
  var traitCounts = Props.traitCounts;
  var grayscale = Props.grayscale;
  var extraTrait = Props.extraTrait;
  var exaltedUnits = Props.exaltedUnits;
  var match = ReactDnd.useDrag({
        type: "hex",
        item: {
          id: "hex " + String(colNum) + " " + String(rowNum),
          colNum: colNum,
          rowNum: rowNum,
          type: "hex",
          unitId: Belt_Option.map(hex, (function (hex) {
                  return TbUtils76.Content.encodeStr(hex.unit);
                })),
          unitItems: Belt_Option.mapWithDefault(hex, [], (function (hex) {
                  return hex.items;
                })),
          starLevel: Belt_Option.map(hex, (function (hex) {
                  return hex.starLevel;
                })),
          traitCounts: traitCounts
        },
        end: (function (unit, monitor) {
            if (!monitor.didDrop()) {
              return Curry._2(onRemove, unit.colNum, unit.rowNum);
            }
            
          }),
        collect: (function (monitor) {
            return {
                    isDragging: monitor.isDragging()
                  };
          })
      });
  var highlight$1 = hex !== undefined && hex.chosenTrait > 0 ? "var(--secondary-11)" : highlight;
  var tmp;
  if (hex !== undefined) {
    var tmp$1 = {
      dragRef: match[1],
      isDragging: match[0].isDragging,
      hexSize: hexSize,
      hex: hex,
      colNum: colNum,
      rowNum: rowNum,
      onRemove: (function (param) {
          return Curry._2(onRemove, colNum, rowNum);
        }),
      onRemoveItem: onRemoveItem,
      onUpdateHex: onUpdateHex,
      onToggleMech: onToggleMech,
      traitCounts: traitCounts,
      exaltedUnits: exaltedUnits
    };
    if (grayscale !== undefined) {
      tmp$1.grayscale = Caml_option.valFromOption(grayscale);
    }
    if (highlightTrait !== undefined) {
      tmp$1.highlightTrait = Caml_option.valFromOption(highlightTrait);
    }
    if (extraTrait !== undefined) {
      tmp$1.extraTrait = Caml_option.valFromOption(extraTrait);
    }
    tmp = React.createElement(TeamPlannerHex76$Unit, tmp$1);
  } else {
    tmp = null;
  }
  var tmp$2 = {
    hexSize: hexSize,
    xGridSize: xGridSize,
    yGridSize: yGridSize,
    extended: extended,
    colNum: colNum,
    rowNum: rowNum,
    onDrop: onDrop,
    onMove: onMove,
    onDropItem: onDropItem,
    onMoveItem: onMoveItem,
    onRemove: onRemove,
    isEmpty: Belt_Option.isNone(hex),
    traitCounts: traitCounts,
    children: tmp
  };
  if (highlight$1 !== undefined) {
    tmp$2.highlight = Caml_option.valFromOption(highlight$1);
  }
  return React.createElement(TbHexWrap.make, tmp$2);
}

var make = TeamPlannerHex76;

export {
  getItemPosition ,
  Item ,
  Unit ,
  make ,
  
}
/* T Not a pure module */
